import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";
import { AddonTemplateInterface } from "../../store/mods_factory/addonTemplatesSlice";

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: modsfactoryUrls.addonTemplatePath(value.id),
    thumbnail_url: modsfactoryUrls.remoteUrl(value.thumbnail_url),
    mcpack_url: modsfactoryUrls.remoteUrl(value.mcpack_url),
    mcpack_second_url: modsfactoryUrls.remoteUrl(value.mcpack_second_url)
  };
}

const addonTemplatesEntity = new schema.Entity(
  'addon_templates',
  {},
  {
    processStrategy
  }
);

const addonTemplateEntity = new schema.Entity(
  'addon_template',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { addon_template: AddonTemplateInterface }>(response.data.addon_template, addonTemplateEntity);
  return normalized.entities;
}

export const fetchAddonTemplates = createAsyncThunk(
  `${PREFIX}_addonTemplates/fetchAddonTemplates`,
  async (params: object = {}) => {
    const response    = await modsFactoryApi.get(`/onesky/addon_templates`, { params })
    const normalized  = normalize<any, { addon_templates: { [key: string]: AddonTemplateInterface } }>(response.data.addon_templates, [addonTemplatesEntity]);

    return {
      addon_templates: normalized.entities?.addon_templates || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchAddonTemplate = createAsyncThunk(
  `${PREFIX}_addonTemplates/fetchAddonTemplate`,
  async (id: number | string) => {
    const response = await modsFactoryApi.get(`/onesky/addon_templates/${id}`);
    return normalizeInstance(response);
  }
);

export const createAddonTemplate = createAsyncThunk(
  `${PREFIX}_addonTemplates/createAddonTemplate`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.post(`/onesky/addon_templates`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateAddonTemplate = createAsyncThunk(
  `${PREFIX}_addonTemplates/updateAddonTemplate`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/addon_templates/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyAddonTemplate = createAsyncThunk(
  `${PREFIX}_addonTemplates/destroyAddonTemplate`,
  async (id: number) => {
    const response = await modsFactoryApi.delete(`/onesky/addon_templates/${id}`);
    return response.data;
  }
);
